var _defs, _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgExitIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "jo7kbzo96a"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 0 1.000000 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#jo7kbzo96a)",
    transform: "translate(-43 -687)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4.667 2.667c.368 0 .666.298.666.666 0 .369-.298.667-.666.667H4v8h.667c.368 0 .666.298.666.667 0 .368-.298.666-.666.666H3.333c-.368 0-.666-.298-.666-.666V3.333l.007-.098c.048-.322.325-.568.66-.568zm6.5 2.065c.287-.14.642-.055.833.215l1.88 2.666c.167.238.162.556-.013.787l-2 2.667c-.126.168-.324.266-.534.266l-.107-.008c-.106-.018-.206-.06-.293-.125l-.08-.072c-.223-.231-.252-.596-.053-.861l1.2-1.6H6.667C6.298 8.667 6 8.368 6 8c0-.368.298-.667.667-.667h5.393L10.913 5.72c0-.002-.002-.003-.003-.005-.211-.301-.138-.717.163-.928z",
    transform: "translate(43 687)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExitIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/exitIcon.271535a8.svg";
export { ForwardRef as ReactComponent };